// 导入axios
import axios from 'axios'


// 请求通用接口 - put
const requestCommonPut = function(url, data){
    // 等待请求完成
    return axios.put(url, data)
}

// 请求通用接口 - post
const requestCommonPost = function(url, data){
    // 等待请求完成
    return axios.post(url, data)
}

// 请求通用接口 - get
const requestCommonGet = function(url, data){
    // 等待请求完成
    return axios.get(url, {params: data})
}

// 拼接url
const urlJoin = function(i_work_order_id){
    return '/api/work_order/clean/' + i_work_order_id + '/'
}

// --------------------------- 到扫工单 --------------------------------
// 创建打扫工单请求
const cleanCreateWorkOrder = function(i_room_id, i_dispatch_user_id, i_deal_user_id){
    
    let data = {
        "work_order_type": 1,
        "work_order_deal_user_id": i_deal_user_id,
        "work_order_dispatch_user_id": i_dispatch_user_id,
        "work_order_room_id": i_room_id,
    }
    // 请求接口
    return requestCommonPost('/api/work_order/', data)
}

// 打扫 - 到店打卡请求
const cleanArrive = function(i_room_id, s_work_order_arrive_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 1,
        "work_order_status": 2,
        "work_order_room_id": i_room_id,
        "work_order_arrive_latitude": s_work_order_arrive_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 打扫 - 打扫前拍照
const cleanBeforePhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 1,
        "work_order_status": 3,
        "work_order_room_id": i_room_id,
        "img_list_three": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 打扫 - 打扫后拍照
const cleanAfterPhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 1,
        "work_order_status": 4,
        "work_order_room_id": i_room_id,
        "img_list_four": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 打扫 - 确认设备正常拍照
const cleanDevicePhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 1,
        "work_order_status": 5,
        "work_order_room_id": i_room_id,
        "img_list_five": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 打扫 - 离店打卡
const cleanLeave = function(i_room_id, s_work_order_leave_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 1,
        "work_order_status": 6,
        "work_order_room_id": i_room_id,
        "work_order_leave_latitude": s_work_order_leave_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// --------------------------- 维修工单 --------------------------------
// 创建维修工单请求
const repairCreateWorkOrder = function(i_room_id, i_dispatch_user_id, i_deal_user_id){
    let data = {
        "work_order_type": 2,
        "work_order_deal_user_id": i_deal_user_id,
        "work_order_dispatch_user_id": i_dispatch_user_id,
        "work_order_room_id": i_room_id,
    }
    // 请求接口
    return requestCommonPost('/api/work_order/', data)
}

// 维修 - 到店打卡请求
const repairArrive = function(i_room_id, s_work_order_arrive_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 2,
        "work_order_status": 2,
        "work_order_room_id": i_room_id,
        "work_order_arrive_latitude": s_work_order_arrive_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 维修 - 维修前问题确认
const repairQuestion = function(i_room_id, i_work_order_id,){
    let data = {
        "work_order_type": 2,
        "work_order_status": 3,
        "work_order_room_id": i_room_id,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 维修 - 维修前拍照
const repairBeforePhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 2,
        "work_order_status": 4,
        "work_order_room_id": i_room_id,
        "img_list_four": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 维修 - 维修后拍照
const repairAfterPhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 2,
        "work_order_status": 5,
        "work_order_room_id": i_room_id,
        "img_list_five": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 维修 - 离店打卡
const repairLeave = function(i_room_id, s_work_order_leave_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 2,
        "work_order_status": 6,
        "work_order_room_id": i_room_id,
        "work_order_leave_latitude": s_work_order_leave_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// --------------------------- 更改玩法 --------------------------------
// 创建更改玩法工单请求
const changePlayCreateWorkOrder = function(i_room_id, i_dispatch_user_id, i_deal_user_id){
    let data = {
        "work_order_type": 3,
        "work_order_deal_user_id": i_deal_user_id,
        "work_order_dispatch_user_id": i_dispatch_user_id,
        "work_order_room_id": i_room_id,
    }
    // 请求接口
    return requestCommonPost('/api/work_order/', data)
}

// 更改玩法 - 到店打卡请求
const changePlayArrive = function(i_room_id, s_work_order_arrive_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 3,
        "work_order_status": 2,
        "work_order_room_id": i_room_id,
        "work_order_arrive_latitude": s_work_order_arrive_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 更改玩法 - 更改前拍照
const changePlayBeforePhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 3,
        "work_order_status": 3,
        "work_order_room_id": i_room_id,
        "img_list_three": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 更改玩法 - 更改后拍照
const changePlayAfterPhoto = function(i_room_id, l_img, i_work_order_id,){
    let data = {
        "work_order_type": 3,
        "work_order_status": 4,
        "work_order_room_id": i_room_id,
        "img_list_four": l_img,
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// 更改玩法 - 离店打卡
const changePlayLeave = function(i_room_id, s_work_order_leave_latitude, i_work_order_id,){
    let data = {
        "work_order_type": 3,
        "work_order_status": 5,
        "work_order_room_id": i_room_id,
        "work_order_leave_latitude": s_work_order_leave_latitude
    }
    // 拼接url
    let sUrl = urlJoin(i_work_order_id)
    // 请求接口
    return requestCommonPut(sUrl, data)
}

// --------------------------- 查询工单 --------------------------------
// 查询所有工单
const getAllWorkOrder = function(){
    // 请求接口
    return requestCommonGet('/api/work_order/', {})
}

// 查询某个包间所有工单
const getRoomWorkOrder = function(i_room_id){
    // 拼接url
    let query = {
        "work_order_room_id": i_room_id
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 查询某个包间正在进行中的工单
const getRoomWorkingWorkOrder = function(i_room_id){
    // 拼接url
    let query = {
        "work_order_room_id": i_room_id,
        "status_filter": 0,
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 查询所有进行中的工单
const getWorkingWorkOrder = function(){
    // 拼接url
    let query = {
        "status_filter": 0,
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 查询已完成工单
const getFinishedWorkOrder = function(){
    // 拼接url
    let query = {
        "work_order_status": 0,
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 查询某个员工正在进行的工单
const getEmployeeWorkingWorkOrder = function(i_employee_id){
    // 拼接url
    let query = {
        "work_order_deal_user_id": i_employee_id,
        "status_filter": 0,
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 查询某个员工已完成的工单
const getEmployeeFinishedWorkOrder = function(i_employee_id){
    // 拼接url
    let query = {
        "work_order_deal_user_id": i_employee_id,
        "work_order_status": 0,
    }
    // 请求接口
    return requestCommonGet('/api/work_order/', query)
}

// 组件导出
export default {
    cleanCreateWorkOrder,
    cleanArrive,
    cleanBeforePhoto,
    cleanAfterPhoto,
    cleanDevicePhoto,
    cleanLeave,
    repairCreateWorkOrder,
    repairArrive,
    repairQuestion,
    repairBeforePhoto,
    repairAfterPhoto,
    repairLeave,
    changePlayCreateWorkOrder,
    changePlayArrive,
    changePlayBeforePhoto,
    changePlayAfterPhoto,
    changePlayLeave,
    getAllWorkOrder,
    getRoomWorkOrder,
    getRoomWorkingWorkOrder,
    getWorkingWorkOrder,
    getFinishedWorkOrder,
    getEmployeeWorkingWorkOrder,
    getEmployeeFinishedWorkOrder,
}
